import { render, staticRenderFns } from "./PaymentRequestButton.vue?vue&type=template&id=ebdb6c0c&"
import script from "./PaymentRequestButton.vue?vue&type=script&lang=ts&"
export * from "./PaymentRequestButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports